<script setup lang="ts">
// types
import type { HeaderMobileDrawerProps } from '@composables/widgets/headers/header-mobile-drawer.hook'
// hooks
import { useHeaderMobileDrawer } from '@composables/widgets/headers/header-mobile-drawer.hook'
// assets
import { faXmark } from '@fortawesome/pro-solid-svg-icons'
// components
import { AppIcon } from '@UI/Icons/AppIcon'
import HeaderLogo from '@Widgets/Headers/HeaderLogo.vue'
import HeaderActions from '@Widgets/Headers/HeaderActions.vue'
import HeaderMobileItem from '@Widgets/Headers/HeaderMobileItem.vue'

defineOptions({
  name: 'HeaderMobileDrawer',
})

const props = defineProps<HeaderMobileDrawerProps>()

const emit = defineEmits<{
  'click:close': []
}>()

const {
  refExpandedIndex,
  expand,
  collapse,
  handleClose,
} = useHeaderMobileDrawer({
  props,
  onClose: () => emit('click:close'),
})
</script>

<template>
  <Teleport to="body">
    <Transition name="drawer">
      <div
        v-if="isOpen"
        class="header-mobile-drawer"
        role="dialog"
        aria-modal="true"
      >
        <div
          class="header-mobile-drawer__backdrop"
          @click="handleClose"
        />
        <div class="header-mobile-drawer__panel">
          <header class="header-mobile-drawer__top">
            <HeaderLogo
              :logo="data.logo"
              :logo-mobile="data.logoMobile"
              :link="data.logoLink"
              mobile
            />
            <button
              type="button"
              class="header-mobile-drawer__close"
              aria-label="Close"
              @click="handleClose"
            >
              <AppIcon
                :icon="faXmark"
                size="medium"
              />
            </button>
          </header>

          <div class="header-mobile-drawer__items">
            <HeaderMobileItem
              v-for="(item, index) in data.topItems"
              :key="`${item.__component}-${item.id}`"
              :item="item"
              :is-expanded="refExpandedIndex === index"
              @click:expand="expand(index)"
              @click:collapse="collapse(index)"
            />
          </div>

          <footer class="header-mobile-drawer__actions">
            <HeaderActions
              :primary="data.primaryButton"
              :secondary="data.secondaryButton"
            />
          </footer>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<style scoped lang="scss" src="@scss/components/Widgets/Headers/HeaderMobileDrawer.scss" />